import { Component, OnInit } from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {AuthService} from '../auth.service';
import {ApiService} from '../api/api.service';
import {Router} from '@angular/router';
import {LayoutManagerService} from '../layout-manager.service';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.css']
})
export class LoginAdminComponent implements OnInit {

  inProgres = false;
  credential = '';

  constructor(
    private authService: AuthService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private router: Router,
    public layoutManager:LayoutManagerService,
    private cookieService: CookieService
  ) { }

  ngOnInit() {
    const email = this.cookieService.get('admin_email');
    console.log(email);
    this.inProgres = true;
    this.api.adminLogin(btoa(email)).subscribe((response) => {
      if (response.result) {
        this.authService.doSignInAdmin(btoa(email));
        this.router.navigateByUrl('/admin_manager')
      }
      this.inProgres = false
    });
  }

  openSnackBar(message: string) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    this.snackBar.open(message, 'Retry', config);
  }

  doLogIn(box: HTMLInputElement) {
    this.credential = box.value;
    if (!this.inProgres) {
      this.inProgres = true;
      this.api.adminLogin(btoa(this.credential)).subscribe(result => {
        if (result.result) {
          this.authService.doSignInAdmin(btoa(this.credential));
          this.cookieService.set( 'admin_email',this.credential);
          this.router.navigateByUrl('/admin_manager')
        }else {
          this.openSnackBar('Wrong credential');
          this.credential = '';
          this.inProgres = false
        }
      });
    }
  }
}
